var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSfund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.331 17.977c.465 2.91 3.569 4.974 5.063 5.642.337 3.078 2.812 6.202 4.007 7.38 1.827-1.67 5.979-5.642 7.96-8.172 2.48-3.164 2.532-7.118 1.424-9.649-.885-2.025-3.532-4.078-4.745-4.851-.036-.722-.306-2.448-1.108-3.587A191.093 191.093 0 0 0 16.191 1 231.715 231.715 0 0 0 9.125 8.33c-3.585 3.9-3.374 6.01-2.794 9.647zm2.426-1.37c.338 2.277 2.004 3.514 2.795 3.848 1.477-3.269 2.162-4.165 4.799-7.54 2.108-2.699.702-6.256-.265-7.697-1.916 1.95-5.863 6.02-6.327 6.696l-.1.145c-.571.817-1.3 1.86-.902 4.546zM20.04 11.65c-.65 1.389-2.342 4.587-3.902 6.274-1.95 2.11-2.584 4.43-2.056 5.906.421 1.18 1.124 2.46 1.423 2.952 1.74-1.582 5.557-5.23 6.907-7.17 1.687-2.426-.053-5.8-.95-6.696-.716-.717-1.247-1.143-1.423-1.266z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfund);
export default __webpack_public_path__ + "static/media/SFUND.683362baf2b1228da82b52979973d5d5.svg";
export { ForwardRef as ReactComponent };